export const AGENDA_MODULE_NAMESPACE = 'agenda';
export const AGENDA_LOADING = 'AGENDA_LOADING';
export const AGENDA_GET_APPOINTMENTS = 'AGENDA_GET_APPOINTMENTS'
export const AGENDA_SET_APPOINTMENTS = 'AGENDA_SET_APPOINTMENTS';
export const AGENDA_GET_APPOINTMENT_BY_ID = 'AGENDA_GET_APPOINTMENT_BY_ID'
export const AGENDA_SET_APPOINTMENT_BY_ID = 'AGENDA_SET_APPOINTMENT_BY_ID';
export const AGENDA_SET_APPOINTMENT_BY_FIELD = 'AGENDA_SET_APPOINTMENT_BY_FIELD';
export const AGENDA_SET_DATE = 'AGENDA_SET_DATE';
export const AGENDA_RECORD = 'AGENDA_RECORD';
export const AGENDA_RECORD_SUCCESS = 'AGENDA_RECORD_SUCCESS';
export const AGENDA_DELETE = 'AGENDA_DELETE';
export const AGENDA_MODIFY = 'AGENDA_MODIFY';
export const AGENDA_SET_CURRENT_APPOINTMENT = 'AGENDA_SET_CURRENT_APPOINTMENT';
export const AGENDA_PUSH_APPOINTMENT = 'AGENDA_PUSH_APPOINTMENT';
export const AGENDA_SET_PARTIAL_PARAMETER = 'AGENDA_SET_PARTIAL_PARAMETER';
export const AGENDA_SET_DATE_APPOINTMENT = 'AGENDA_SET_DATE_APPOINTMENT';

export const AGENDA_GET_APPOINTMENTS_TICKET = 'AGENDA_GET_APPOINTMENTS_TICKET'
export const AGENDA_ASSIGN_APPOINTMENT = 'AGENDA_ASSIGN_APPOINTMENT'

export const AGENDA_SET_LOADER_STATE = 'AGENDA_SET_LOADER_STATE'
export const AGENDA_LOADERS = Object.freeze({
    RESOURCES: 'AGENDA_RESOURCES'
})



// WEBPACK FOOTER //
// ./src/store/agenda/agenda-types.store.ts